// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/SetPassword.css */
.set-password-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 2rem;
}

.set-password-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  padding: 3rem;
  max-width: 500px;
  width: 100%;
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.set-password-card h2 {
  margin: 0 0 1rem 0;
  color: #333;
  text-align: center;
  font-size: 1.8rem;
}

.welcome-text {
  text-align: center;
  color: #666;
  margin-bottom: 2rem;
  line-height: 1.6;
  font-size: 0.95rem;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: #333;
  font-weight: 600;
  font-size: 0.95rem;
}

.form-group input {
  width: 100%;
  padding: 0.8rem;
  border: 2px solid #ddd;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s, box-shadow 0.3s;
  box-sizing: border-box;
}

.form-group input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-group input.error {
  border-color: #ff4444;
}

.form-group input.error:focus {
  box-shadow: 0 0 0 3px rgba(255, 68, 68, 0.1);
}

.error-text {
  color: #ff4444;
  font-size: 0.875rem;
  display: block;
  margin-top: 0.5rem;
}

.password-hint {
  display: block;
  margin-top: 0.5rem;
  color: #999;
  font-size: 0.85rem;
}

.success-message {
  background: #d4edda;
  border: 1px solid #c3e6cb;
  color: #155724;
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  text-align: center;
  font-weight: 500;
}

.error-message {
  background: #f8d7da;
  border: 1px solid #f5c6cb;
  color: #721c24;
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  text-align: center;
  font-weight: 500;
}

.submit-btn {
  width: 100%;
  padding: 1rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.submit-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.3);
}

.submit-btn:active:not(:disabled) {
  transform: translateY(0);
}

.submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.back-btn {
  width: 100%;
  padding: 1rem;
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  margin-top: 1rem;
  transition: background 0.3s;
}

.back-btn:hover {
  background: #5a6268;
}

.login-link {
  text-align: center;
  margin-top: 1.5rem;
  color: #666;
  font-size: 0.95rem;
}

.login-link a {
  color: #667eea;
  text-decoration: none;
  font-weight: 600;
}

.login-link a:hover {
  text-decoration: underline;
}

/* Loading state styles */
.set-password-card p {
  text-align: center;
  color: #666;
  line-height: 1.6;
}

/* Responsive Design */
@media (max-width: 600px) {
  .set-password-card {
    padding: 2rem 1.5rem;
  }

  .set-password-container {
    padding: 1rem;
  }

  .set-password-card h2 {
    font-size: 1.5rem;
  }

  .welcome-text {
    font-size: 0.9rem;
  }
}

/* Focus visible for accessibility */
.submit-btn:focus-visible,
.back-btn:focus-visible {
  outline: 3px solid #667eea;
  outline-offset: 2px;
}

.form-group input:focus-visible {
  outline: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/SetPassword.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,6DAA6D;EAC7D,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,oCAAoC;AACpC;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf","sourcesContent":["/* src/pages/SetPassword.css */\n.set-password-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  padding: 2rem;\n}\n\n.set-password-card {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);\n  padding: 3rem;\n  max-width: 500px;\n  width: 100%;\n  animation: fadeIn 0.3s ease-in;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.set-password-card h2 {\n  margin: 0 0 1rem 0;\n  color: #333;\n  text-align: center;\n  font-size: 1.8rem;\n}\n\n.welcome-text {\n  text-align: center;\n  color: #666;\n  margin-bottom: 2rem;\n  line-height: 1.6;\n  font-size: 0.95rem;\n}\n\n.form-group {\n  margin-bottom: 1.5rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  color: #333;\n  font-weight: 600;\n  font-size: 0.95rem;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 0.8rem;\n  border: 2px solid #ddd;\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: border-color 0.3s, box-shadow 0.3s;\n  box-sizing: border-box;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.form-group input.error {\n  border-color: #ff4444;\n}\n\n.form-group input.error:focus {\n  box-shadow: 0 0 0 3px rgba(255, 68, 68, 0.1);\n}\n\n.error-text {\n  color: #ff4444;\n  font-size: 0.875rem;\n  display: block;\n  margin-top: 0.5rem;\n}\n\n.password-hint {\n  display: block;\n  margin-top: 0.5rem;\n  color: #999;\n  font-size: 0.85rem;\n}\n\n.success-message {\n  background: #d4edda;\n  border: 1px solid #c3e6cb;\n  color: #155724;\n  padding: 1rem;\n  border-radius: 8px;\n  margin-bottom: 1.5rem;\n  text-align: center;\n  font-weight: 500;\n}\n\n.error-message {\n  background: #f8d7da;\n  border: 1px solid #f5c6cb;\n  color: #721c24;\n  padding: 1rem;\n  border-radius: 8px;\n  margin-bottom: 1.5rem;\n  text-align: center;\n  font-weight: 500;\n}\n\n.submit-btn {\n  width: 100%;\n  padding: 1rem;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.submit-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.3);\n}\n\n.submit-btn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.submit-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.back-btn {\n  width: 100%;\n  padding: 1rem;\n  background: #6c757d;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  margin-top: 1rem;\n  transition: background 0.3s;\n}\n\n.back-btn:hover {\n  background: #5a6268;\n}\n\n.login-link {\n  text-align: center;\n  margin-top: 1.5rem;\n  color: #666;\n  font-size: 0.95rem;\n}\n\n.login-link a {\n  color: #667eea;\n  text-decoration: none;\n  font-weight: 600;\n}\n\n.login-link a:hover {\n  text-decoration: underline;\n}\n\n/* Loading state styles */\n.set-password-card p {\n  text-align: center;\n  color: #666;\n  line-height: 1.6;\n}\n\n/* Responsive Design */\n@media (max-width: 600px) {\n  .set-password-card {\n    padding: 2rem 1.5rem;\n  }\n\n  .set-password-container {\n    padding: 1rem;\n  }\n\n  .set-password-card h2 {\n    font-size: 1.5rem;\n  }\n\n  .welcome-text {\n    font-size: 0.9rem;\n  }\n}\n\n/* Focus visible for accessibility */\n.submit-btn:focus-visible,\n.back-btn:focus-visible {\n  outline: 3px solid #667eea;\n  outline-offset: 2px;\n}\n\n.form-group input:focus-visible {\n  outline: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
